import React from 'react';
import TableComponent from './TableComponent';
import TableFilterComponent from './TableFilterComponent';

/**
 * DataTable - Listagem padrão: busca + filtros em drawer + tabela paginada.
 *
 * @param {Object} list - Retorno de useTableList
 * @param {Array} filters - Filtros do drawer (ver TableFilterComponent)
 * @param {string} searchPlaceholder - Placeholder da busca
 * Demais props são repassadas ao TableComponent (columns, onEdit, editTo, onDelete, emptyMessage...).
 */
function DataTable({ list, filters = [], searchPlaceholder, emptyMessage, ...tableProps }) {
    return (
        <>
            <TableFilterComponent
                filters={filters}
                filterValues={list.filterValues}
                searchValue={list.searchValue}
                searchPlaceholder={searchPlaceholder}
                onApply={(search, values) => list.load(1, search, values)}
                onClear={() => list.load(1, '', {})}
            />
            <TableComponent
                data={list.rows}
                pagination
                currentPage={list.pagination.currentPage}
                perPage={list.pagination.perPage}
                totalItems={list.pagination.totalItems}
                onPageChange={(page) => list.load(page)}
                emptyMessage={list.loaded ? emptyMessage : ''}
                {...tableProps}
            />
        </>
    );
}

export default DataTable;
